import type { BackgroundJobScheduleInput } from "@/api/background-job/_models/BackgroundJobSchedule";

/** A new schedule's starting values in the editor: hourly at :05, enabled. */
export const toJobScheduleEmptyInput = (kind: string): BackgroundJobScheduleInput => {
  return {
    name: "",
    kind,
    frequency: "HOURLY",
    intervalMinutes: 15,
    minute: 5,
    time: "06:00",
    weekdays: [],
    enabled: true,
  };
};

/** ISO weekdays (1 = Mon … 7 = Sun) as the editor's buttons show them. */
export const JOB_SCHEDULE_WEEKDAYS: { day: number; label: string }[] = [
  { day: 1, label: "M" },
  { day: 2, label: "T" },
  { day: 3, label: "W" },
  { day: 4, label: "T" },
  { day: 5, label: "F" },
  { day: 6, label: "S" },
  { day: 7, label: "S" },
];
